var map = {
	"./abacus_new.png": "IbZ7",
	"./axept.png": "QD9w",
	"./axonivy.png": "tIqR",
	"./easylearn.png": "204W",
	"./ibm.png": "KMxq",
	"./obt.png": "7HBD",
	"./officeatwork.png": "QnjR",
	"./pentaho.png": "slOS"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nrF/";